export default __webpack_public_path__ + "static/media/noMsg.dc0b052b.svg";